var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"text-center",staticStyle:{"cursor":"pointer"}},[_c('lenon-profile-photo',{attrs:{"size":"100","photo":_vm.logo}}),_c('h5',{staticClass:"mb-25 font-weight-bolder"},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }